import { formatNumbers } from 'core/helpers/format-numbers'

import c from './assets/sass/user-card.module.scss'

export const UserCard = ({ user, onClick }) => {
    const avatar = user.photoUrl || '/images/avatar.png'
    const displayName = user.username || user.firstName || 'Пользователь'
    const firstLetter = displayName.charAt(0).toUpperCase()

    return (
        <div className={c.component} onClick={onClick}>
            {user.photoUrl ? (
                <img src={avatar} alt={displayName} className={c.avatar} />
            ) : (
                <div className={c.avatarPlaceholder}>{firstLetter}</div>
            )}
            <div className={c.info}>
                <span className={c.name}>{displayName}</span>
                <span className={c.tgId}>TG ID: {user.telegramId}</span>
                <span className={c.balance}>
                    💰 {formatNumbers(parseInt(user.balance || 0))}
                </span>
            </div>
            <div className={c.stats}>
                <span>Lvl {user.level}</span>
                <span>Ref: {user.referralsCount}</span>
                {user.referralLevel > 0 && (
                    <span>🎖️ L{user.referralLevel}</span>
                )}
            </div>
        </div>
    )
}
